import { createContext, useContext, Dispatch } from 'react'

export enum ActionKind {
  JOBSBOX_START = 'jobsbox-start',
  JOBSBOX_CLOSE = 'jobsbox-close',
  LOGOUT_CLOSE = 'logout-close',
  LOGOUT_OPEN = 'logout-open',
}

export type Action = {
  type: ActionKind
  payload?: any
}

export const initialData = {
  jobsBox: { from: 0 },
  logout: { open: false },
}

export type DataType = typeof initialData

export const reducerContext = createContext<[DataType, Dispatch<Action>] | null>(null)

export function useReducerContext() {
  return useContext(reducerContext)!
}

export function reducer(draft: DataType, action: Action): DataType | void {
  const { type, payload } = action
  switch (type) {
    case ActionKind.JOBSBOX_START:
      if (isNaN(payload)) {
        throw Error('action payload type must be number type')
      }
      draft.jobsBox.from = payload
      break
    case ActionKind.JOBSBOX_CLOSE:
      draft.jobsBox.from = 0
      break
    case ActionKind.LOGOUT_CLOSE:
      draft.logout.open = false
      break
    case ActionKind.LOGOUT_OPEN:
      draft.logout.open = true
      break
    default:
      throw Error('Unkonwn action: ' + type) // eslint-disable-line prefer-template
  }
}
